<template>
    <footer class="footer-bar" id="footerBar2" ref="footerBar" :class="{heigher: !$cookie.get('c00kie')}">
        <div class="wrapper">
            <div class="footer-bar__content">
                <p class="footer-bar__content__name">TreeTopTrip</p>
                <div class="footer-bar__content__info">
                    <span class="footer-bar__content__info__address">
                        Gęsia 8/209
                        <br>
                        31-535 Kraków, PL
                    </span>
                    <span class="footer-bar__content__info__contact">
                        office@treetoptrip.com
                        <br>
                        +48 535 486 014
                    </span>
                    <span class="footer-bar__content__info__social">
                        <a href="https://pl.linkedin.com/company/treetoptrip" target="_blank">
                            <vk-icon icon="linkedin"></vk-icon>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>

    export default {
        name: 'footer-bar',
    }
</script>

<style lang="scss" scoped>
    .footer-bar {
        height: 160px;
        background-color: #3b3d40;

        &__content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;
            
            &__name {
                color: white;
                margin: 0;
                font-family: dubiel;
                font-size: 2.2rem;
            }

            &__info {
                display: flex;
                
                &__address {
                    margin: 0;
                    color: #999;
                    font-family: Kazimir;
                }
                
                &__contact {
                    margin: 0 0 0 40px;
                    color: #999;
                    font-family: Kazimir;
                }
                &__social {
                    margin: auto 0 auto 40px;
                    a {
                        color: #999;

                        &:hover  svg{
                            color: #ff5400;
                        }
                    }
                }
            }
        }
    }
    @media all and (max-width: 830px) {
        .footer-bar {
            height: 60px;

            &__content{
                &__name {
                    font-size: 1.8rem;
                }

                span {
                    font-size: 12px
                }
            }
        }
    }

    @media all and (max-width: 530px) {
        .footer-bar {
            height: 140px;

            &__content{
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                &__name {
                    font-size: 1.8rem;
                    margin: 15px 0;
                    width: 100%;
                    text-align: center;
                }

                &__info {
                    justify-content: space-around;
                    width: 100%;

                    &__address{
                        text-align: center;
                    }

                    &__contact {
                        margin: 0;
                        text-align: center;
                    }

                    &__social {
                        margin: auto 0;
                    }
                }
            }
        }
    }
</style>